/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Webhook_Address_NoteInputs */



/**
* | output |
* | --- |
* | "The address identifies this connection, so treat it like a password. You can show it again under Settings → Integrations, in this connection's “Update creden..." |
*
* @param {Spaces_Webhook_Address_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_webhook_address_note = /** @type {((inputs?: Spaces_Webhook_Address_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Webhook_Address_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Adresse identifiziert diese Verbindung, behandle sie also wie ein Passwort. Du kannst sie unter Einstellungen → Integrationen bei dieser Verbindung über „Zugangsdaten aktualisieren“ erneut anzeigen.")
	return /** @type {LocalizedString} */ ("The address identifies this connection, so treat it like a password. You can show it again under Settings → Integrations, in this connection's “Update credentials”.")
});